import axios from 'axios';
import configBase from 'configBase';

export const verificaCache = (cb) => {
  axios.get(configBase.api + 'Operadoras/versao2?access_token='+localStorage.getItem('planos_t'))
  .then((response) => {
    let v = localStorage.getItem('planos_vers');

    if (v) {
      if (v !== response.data.versao) {
        localStorage.setItem('planos_vers', response.data.versao);
        window.location.reload(true);
      }
      else
        return cb({erro: false});
    }
    else {
      localStorage.setItem('planos_vers', response.data.versao);
      window.location.reload(true);
    }
  })
  .catch(function (erro) {
    if (erro.response) {
      // Token expirado (sem acesso)
      if (erro.response.status === 401) {
        alert("Seção expirada! Por favor refazer login novamente.");
        window.location.href = configBase.front + 'panel/sair';
      }
      else
        return cb({erro: true, mensagem: erro.response.status + ' - Sem acesso ao servidor. Por favor, verifique a conexão com a internet.'});
    }
    else
      return cb({erro: true, mensagem: 'Sem acesso ao servidor. Por favor, verifique a conexão com a internet.'});
  });
}